/** Erlaubte IDs für Share-Score-Card-HTML-Templates (Konfigurator + API + Share-Seite). */

export const SCORE_CARD_HTML_TEMPLATE_IDS = ['ambition-default', 'symplr', 'compact'] as const;

export type ScoreCardHtmlTemplateId = (typeof SCORE_CARD_HTML_TEMPLATE_IDS)[number];

export const DEFAULT_SCORE_CARD_HTML_TEMPLATE: ScoreCardHtmlTemplateId = 'ambition-default';

/** Anzeigenamen für Dropdowns (Ambition = ambition-default). */
export const SCORE_CARD_HTML_TEMPLATE_LABELS: Record<ScoreCardHtmlTemplateId, string> = {
  'ambition-default': 'Ambition',
  symplr: 'symplr',
  compact: 'Compact (Test)',
};

export const SCORE_CARD_HTML_TEMPLATE_FILES: Record<ScoreCardHtmlTemplateId, string> = {
  'ambition-default': 'ambition-default.html',
  symplr: 'symplr.html',
  compact: 'compact.html',
};

export function isValidScoreCardHtmlTemplate(id: unknown): id is ScoreCardHtmlTemplateId {
  return typeof id === 'string' && SCORE_CARD_HTML_TEMPLATE_IDS.includes(id as ScoreCardHtmlTemplateId);
}

export function normalizeScoreCardHtmlTemplate(id: unknown): ScoreCardHtmlTemplateId {
  if (id === 'minimal') return 'symplr';
  return isValidScoreCardHtmlTemplate(id) ? id : DEFAULT_SCORE_CARD_HTML_TEMPLATE;
}
